import { createFileRoute, redirect } from "@tanstack/react-router";
import { SettingsList } from "../../screens/settings/index.ts";

/**
 * `/settings`: on a computer it opens the first page (the sidebar is the list); on a phone it is the list, and
 * each section pushes in over it.
 */
export const Route = createFileRoute("/_app/settings/")({
  // On a computer the first page is decided before anything draws, so hovering "Settings" already fetches it.
  // The query is `PHONE_QUERY` in @adea/ui (not imported here: this part of the route loads with the app).
  beforeLoad: () => {
    if (typeof window !== "undefined" && !window.matchMedia("(max-width: 819px)").matches)
      throw redirect({ to: "/settings/profile", replace: true });
  },
  component: SettingsList,
});
